import { c as _c } from "react/compiler-runtime";
import { useLocale, useTranslations } from "next-intl";
import { RealEstateType } from "@/types/real-estate";
import { useRealEstateDetailMobileFooter } from "../useRealEstateDetailMobileFooter";
import { formatSmartAvailability } from "@/lib/time";
import { getFirstName } from "@/lib/name";
type Props = {
  detailData: RealEstateType;
};
export function useRealEstateDetailMobileMessageFab(t0) {
  const $ = _c(13);
  const {
    detailData
  } = t0;
  const t = useTranslations("modules.realEstateDetail");
  const locale = useLocale();
  let t1;
  if ($[0] !== detailData) {
    t1 = {
      detailData
    };
    $[0] = detailData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    handleSendMessage,
    user,
    availableFrom
  } = useRealEstateDetailMobileFooter(t1);
  let t2;
  if ($[2] !== t || $[3] !== user?.name) {
    const firstName = getFirstName(user?.name);
    t2 = firstName ? t("messageUser", {
      name: firstName
    }) : t("sendMessage");
    $[2] = t;
    $[3] = user?.name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const label = t2;
  let t3;
  if ($[5] !== availableFrom || $[6] !== locale) {
    t3 = availableFrom ? formatSmartAvailability(availableFrom, locale === "pt" ? "pt" : "enGB") : "";
    $[5] = availableFrom;
    $[6] = locale;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const availability = t3;
  let t4;
  if ($[8] !== availability || $[9] !== handleSendMessage || $[10] !== label || $[11] !== user) {
    t4 = {
      handleSendMessage,
      user,
      label,
      availability
    };
    $[8] = availability;
    $[9] = handleSendMessage;
    $[10] = label;
    $[11] = user;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}